import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

interface ISpills {
  personalPrecautions?: string;
  environmentalPrecautions?: string;
  containmentAndCleanUp?: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const Spills: React.FC<ISpills> = ({
  personalPrecautions,
  environmentalPrecautions,
  containmentAndCleanUp,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel9`)}
      key={'panel9'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel9bh-content`}
        id={`panel9bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.spills')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {personalPrecautions && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.personal_precautions')}</b> ${personalPrecautions}` }} />
        )}
        {environmentalPrecautions && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.environmental_precautions')}</b> ${environmentalPrecautions}` }} />
        )}
        {containmentAndCleanUp && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.containment_and_clean_up')}</b> ${containmentAndCleanUp}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default Spills;
